import type { AppModule } from "../types";
import { s } from "./strings";

/** Expense tracking is premium in Clockify and free here; hidden only while the workspace switch is off (spec 2). */
export const expensesModule: AppModule = {
  name: "expenses",
  routes: {
    shell: [
      {
        path: "/expenses",
        handle: { title: s.pageTitle },
        lazy: () => import("./pages/ExpensesPage").then((m) => ({ Component: m.ExpensesPage })),
      },
      {
        path: "/reports/expense/detailed",
        handle: { title: s.reportTitle },
        lazy: () => import("./pages/ExpenseReportPage").then((m) => ({ Component: m.ExpenseReportPage })),
      },
    ],
  },
  sidebar: [
    {
      id: "EXPENSES",
      label: s.sidebar,
      path: "/expenses",
      icon: "expenses",
      alt: "View Expenses",
      visible: (ctx) => ctx.workspaceSettings.expensesEnabled !== false,
    },
  ],
};
